/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PagedResponseOfRoleListEntryFromJSON, RoleRequestToJSON, RoleResponseFromJSON, } from '../models';
/**
 *
 */
var RoleRestControllerApi = /** @class */ (function (_super) {
    __extends(RoleRestControllerApi, _super);
    function RoleRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new role  \'Permission#CREATE_ROLE\' is required to access to this endpoint
     * Create a new role  \'Permission#CREATE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.createRoleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.roleRequest === null || requestParameters.roleRequest === undefined) {
                            throw new runtime.RequiredError('roleRequest', 'Required parameter requestParameters.roleRequest was null or undefined when calling createRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/roles",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: RoleRequestToJSON(requestParameters.roleRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return RoleResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new role  \'Permission#CREATE_ROLE\' is required to access to this endpoint
     * Create a new role  \'Permission#CREATE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.createRole = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRoleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete role  \'Permission#DELETE_ROLE\' is required to access to this endpoint
     * Delete role  \'Permission#DELETE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.deleteRoleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
                            throw new runtime.RequiredError('roleId', 'Required parameter requestParameters.roleId was null or undefined when calling deleteRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/roles/{roleId}".replace("{".concat("roleId", "}"), encodeURIComponent(String(requestParameters.roleId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete role  \'Permission#DELETE_ROLE\' is required to access to this endpoint
     * Delete role  \'Permission#DELETE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.deleteRole = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRoleRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get role details  \'Permission#READ_ROLE\' is required to access to this endpoint
     * Get role details  \'Permission#READ_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.getRoleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
                            throw new runtime.RequiredError('roleId', 'Required parameter requestParameters.roleId was null or undefined when calling getRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/roles/{roleId}".replace("{".concat("roleId", "}"), encodeURIComponent(String(requestParameters.roleId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return RoleResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get role details  \'Permission#READ_ROLE\' is required to access to this endpoint
     * Get role details  \'Permission#READ_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.getRole = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List roles using pagination  \'Permission#READ_ROLE\' is required to access to this endpoint
     * List roles using pagination  \'Permission#READ_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.listRolesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/roles",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfRoleListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List roles using pagination  \'Permission#READ_ROLE\' is required to access to this endpoint
     * List roles using pagination  \'Permission#READ_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.listRoles = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRolesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update role  \'Permission#UPDATE_ROLE\' is required to access to this endpoint
     * Update role  \'Permission#UPDATE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.updateRoleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
                            throw new runtime.RequiredError('roleId', 'Required parameter requestParameters.roleId was null or undefined when calling updateRole.');
                        }
                        if (requestParameters.roleRequest === null || requestParameters.roleRequest === undefined) {
                            throw new runtime.RequiredError('roleRequest', 'Required parameter requestParameters.roleRequest was null or undefined when calling updateRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/roles/{roleId}".replace("{".concat("roleId", "}"), encodeURIComponent(String(requestParameters.roleId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: RoleRequestToJSON(requestParameters.roleRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return RoleResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update role  \'Permission#UPDATE_ROLE\' is required to access to this endpoint
     * Update role  \'Permission#UPDATE_ROLE\' is required to access to this endpoint
     */
    RoleRestControllerApi.prototype.updateRole = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRoleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RoleRestControllerApi;
}(runtime.BaseAPI));
export { RoleRestControllerApi };
